import styled from "styled-components";
import WrapperContainer from "../Containers/WrapperContainer";
import { InputStyles, InputTitleWrapper } from "../Input/styled";
import { SelectedItemsListWrapper } from "../DropdownMultiselectInput/styled";
import { colors } from "../../consts";

export const ChipsWrapper = styled(WrapperContainer)`
  ${InputStyles}
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-height: 48px;
  height: unset;

  ${SelectedItemsListWrapper} {
    padding-top: 4px;
    padding-bottom: 4px;
    width: 100% !important;

    margin-right: 12px;

    ul {
      width: 100% !important;
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
    }
  }

  ${InputTitleWrapper} {
    margin-bottom: 2px;
  }

  input {
    flex-grow: 1;
    border: none;
    outline: none;
    padding: 4px 8px;
    width: 130px;
    max-width: 100%;
    padding: 0;

    font-size: 16px;
    color: ${colors.RAISIN_100};

    &::placeholder {
      color: ${colors.RAISIN_50};
    }
  }
`;

export const InputLabel = styled.label`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
